import { useEffect, useRef, useState } from "react";
import { retrieveData } from "../apis/dataService";
import { useCalculator } from "../assets/js/ContextProviders/CalculatorContext";
import { useOnScreen } from "../assets/js/ContextProviders/OnScreenContext";

function ReviewsGear() {
    const [deg, setDeg] = useState(26);
    const { Add, Percentage } = useCalculator();

    // CHECK IS REVIEWGEAR IS ONSCREEN OR NOT:
    const { isOnScreen, DivScreenRef, checkIfOnScreen } = useOnScreen();
    useEffect(() => {
        // CHECKIFONSCREEN WHEN THE REVIEWFORM HEIGHT ETC CHANGES:
        const ReviewForm = document.querySelector('.ReviewForm-parent');
        const handleResize = () => {
            checkIfOnScreen();
        };
        // Initialize ResizeObserver
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(ReviewForm);

        // CHECKIFONSCREEN WHENEVER THE COMPONENT UNMOUNTS:
        handleResize();

        // CHECKIFONSCREEN WHENEVER THE USER SCROLL:
        const handleScroll = () => {
            checkIfOnScreen();
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            // Remove the EventListener when the component is unmounted
            window.removeEventListener('scroll', handleScroll);
            // Disconnect the ResizeObserver when the component is unmounted
            resizeObserver.disconnect();
        };
    }, []);

    // RETRIEVE ALL REVIEWS FROM MONGODB:
    const [ReviewsArray, setReviewsArray] = useState([])
    useEffect(() => {
        retrieveData({
            api: '/reviews-form',
            var: 'RatingStars'
        })
            .then(data => {
                setReviewsArray(data)
            })
            .catch(error => {
                console.error('Error in fetchData:', error);
            });
    }, [])


    // FIND THE AVERAGE FROM THE TOTAL REVIEWS STARS:
    const [Reviews, setReviews] = useState(0);
    useEffect(() => {
        if (ReviewsArray) {
            setReviews((Add(ReviewsArray) / ReviewsArray.length))
        }
    }, [ReviewsArray])

    const formattedReviews = Reviews.toFixed(1);
    const reviewsGearRef = useRef(null);
    useEffect(() => {

        const maxDeg = 243;
        const minDeg = 26;
        const finalDeg = ((Reviews / 5) * (maxDeg - minDeg)) + minDeg;

        const initialInterval = 30;
        let currentInterval = initialInterval;

        if (isOnScreen) {
            const handleInterval = () => {
                let reviewsGearElement = reviewsGearRef.current;

                if (reviewsGearElement) {
                    let style = window.getComputedStyle(reviewsGearElement);
                    let transformValue = style.getPropertyValue('transform');
                    let matrix = transformValue.split('(')[1].split(')')[0].split(',');
                    let angle = Math.atan2(matrix[1], matrix[0]) * (180 / Math.PI);
                    angle = (angle + 360) % 360;

                    setDeg(prevDeg => angle);
                    reviewsGearElement.style.transform = `rotate(${finalDeg}deg)`;

                    if (deg > 96) {
                        reviewsGearElement.style.borderRight = '30px solid var(--green)';
                    } else {
                        reviewsGearElement.style.borderRight = '30px solid var(--unfilled)';
                    }

                    if (deg > 200) {
                        reviewsGearElement.style.borderTop = '30px solid var(--green)';
                    } else {
                        reviewsGearElement.style.borderTop = '30px solid var(--unfilled)';
                    }
                }
            };

            // Initial interval with a faster rate
            let intervalId = setInterval(handleInterval, currentInterval);
            const timeoutId = setTimeout(() => {
                // After 2 seconds, switch to a slower interval
                clearInterval(intervalId);
                currentInterval = 3000;
                intervalId = setInterval(handleInterval, currentInterval);
            }, 1500);
            return () => {
                clearInterval(intervalId);
                clearTimeout(timeoutId);
            };
        } else {
            let reviewsGearElement = reviewsGearRef.current;
            reviewsGearElement.style.transform = `rotate(${minDeg}deg)`
            reviewsGearElement.style.borderRight = '30px solid var(--unfilled)';
            reviewsGearElement.style.borderTop = '30px solid var(--unfilled)';
            setDeg(26)
        }

    }, [Reviews, reviewsGearRef, deg, isOnScreen]);

    return (
        <>
            <div className="ReviewsGear-parent" ref={DivScreenRef}>
                <div className="ReviewsGear" ref={reviewsGearRef}>
                </div>
                <div className="Rating-no">
                    {formattedReviews}
                </div>
                <div className="Rating-no-total">
                    {ReviewsArray.length} Ratings
                </div>
                <div className="Reviewfeets1"></div>
                <div className="Reviewfeets2"></div>
            </div>
        </>
    );
}

export default ReviewsGear;